<template>
  <div class="btn-copy-container">
    <b-button
      size="sm"
      variant="light"
      :id="id"
      type="button"
      @click.prevent="handleClick"
      @mouseover="handleMouseOver"
      @mouseleave="handleMouseLeave"
    >
      <font-awesome-icon fas :icon="['fas', 'copy']" size="lg" />
    </b-button>
    <b-tooltip
      placement="left"
      ref="tipHover"
      :disabled.sync="disabled"
      :target="id"
      :title="titleCopy"
    ></b-tooltip>
    <b-tooltip
      placement="left"
      ref="tipClick"
      :disabled.sync="disabled"
      :target="id"
      :title="titleCopied"
    ></b-tooltip>
  </div>
</template>

<script>
export default {
	props: {
		target: {
			type: String,
			default: () => '',
		},
	},
	computed: {
		id() {
			return 'btn-copy_' + uuidv4()
		},
	},
	data() {
		return {
			disabled: true,
			titleCopy: this.$t('copy to clipboard'),
			titleCopied: this.$t('copied', '!'),
		}
	},
	methods: {
		handleMouseLeave() {
			this.$refs.tipClick.$emit('close')
			this.$refs.tipHover.$emit('close')
		},
		handleMouseOver() {
			this.$refs.tipClick.$emit('close')
			this.$refs.tipHover.$emit('open')
		},
		handleClick() {
			this.$refs.tipHover.$emit('close')
			this.$refs.tipClick.$emit('open')
			window.copyToClipboard(this.target)
		},
	},
}
</script>

<style lang="scss">
.btn-copy-container {
	position: absolute;
	top: 0;
	z-index: 12;
	right: 0;
	margin: 5px;
	button {
		margin: 0;
		padding: 4px 8px;
		&:active,
		&:focus {
			box-shadow: none;
		}
	}
}
</style>
